import { getAxiosClient } from "../../axios-client";
import {
  UpdateOfferSubcontractorRequestBody,
  UpdateOfferSubcontractorResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const offerSubcontractorUpdate = async (
  body: UpdateOfferSubcontractorRequestBody
) => {
  return await axiosClient.ax.put<UpdateOfferSubcontractorResponse>(
    "/Offers/UpdateOfferSubcontractor",
    body
  );
};
